function BtnSecondary({ text, icon, href, download = false }) {
  return (
    <a
      className="btn-secondary"
      href={href}
      download={download}
      target={download ? undefined : "_blank"}
      rel={download ? undefined : "noopener noreferrer"}
    >
      <span>{text}</span>
      {icon && <span className="btn-icon">{icon}</span>}
    </a>
  );
}

export default BtnSecondary;
